import { useState } from 'react';

export default function useToken() {
  const getToken = () => {
    const tokenString = sessionStorage.getItem('token');
    return tokenString ? tokenString : null;
  };

  const [token, setToken] = useState(getToken());

  const saveToken = userToken => {
    console.log(userToken);
    sessionStorage.setItem('token', userToken);
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    token
  }
}